var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row wrapper-spacing" }, [
    _vm.items.length
      ? _c("div", { staticClass: "small-12 columns" }, [
          _c("h1", [
            _c("div", { staticClass: "spv-info-wrapper info-trend" }, [
              _vm._v("Monatliche "),
              _c("div", { staticClass: "info-overlay" }, [
                _vm._v("Wertentwicklung "),
                _vm._m(0),
                _c("div", { staticClass: "info-overlay__text" }, [
                  _vm._v(_vm._s(_vm.infoText[0]))
                ])
              ])
            ]),
            _c("div", { staticClass: "spv-info-wrapper text-only" }, [
              _vm._v(
                " " + _vm._s(_vm.indexName) + " " + _vm._s(_vm.month) + " "
              )
            ]),
            _c("div", { staticClass: "spv-info-wrapper info-trend" }, [
              _c("span", { staticClass: "text-normal" }, [
                _vm._v("mit Zielvolatilität ")
              ]),
              _c("div", { staticClass: "info-overlay" }, [
                _c("span", { staticClass: "text-normal" }, [
                  _vm._v(_vm._s(_vm.targetVol) + " ")
                ]),
                _vm._m(1),
                _c("div", { staticClass: "info-overlay__text" }, [
                  _vm._v(_vm._s(_vm.infoText[1]))
                ])
              ])
            ])
          ]),
          _c("div", { staticClass: "spv-table-wrapper" }, [
            _c(
              "table",
              {
                staticClass:
                  "spv-product-table spv-index-table spv-index-table--trend"
              },
              [
                _c("thead", [
                  _c("tr", [
                    _c("th", { staticClass: "medium-8 large-9" }, [
                      _vm._v("Indexstichtag"),
                      _c("br"),
                      _vm._v(
                        _vm._s(_vm.month === "Juni" ? "01.06." : "01.12.") +
                          _vm._s(_vm.year)
                      )
                    ]),
                    _c("th", { staticClass: "medium-4 large-3" }, [
                      _c(
                        "div",
                        { staticClass: "spv-info-wrapper flex-wrapper" },
                        [
                          _vm._m(2),
                          _vm.indexId === "trend"
                            ? _c("div", { staticClass: "info-overlay" }, [
                                _vm._m(3),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "info-overlay__text right-aligned"
                                  },
                                  [_vm._v(_vm._s(_vm.infoText[2]))]
                                )
                              ])
                            : _vm._e()
                        ]
                      )
                    ])
                  ])
                ]),
                _c(
                  "tbody",
                  _vm._l(_vm.items, function(item, index) {
                    return _c("tr", { key: index }, [
                      _c("td", [
                        _vm._v(_vm._s(_vm.$parent.formatDate(item.date)))
                      ]),
                      _c("td", [
                        _vm._v(
                          _vm._s(_vm.$parent.formatMoney(item.index_value, 2))
                        )
                      ])
                    ])
                  })
                ),
                _c("tfoot", [
                  _c("tr", [
                    _c("td", { staticClass: "td-padding" }, [
                      _c("div", { staticClass: "spv-info-wrapper" }, [
                        _vm._v("Jahresrendite "),
                        _c("div", { staticClass: "info-overlay" }, [
                          _vm._m(4),
                          _c(
                            "div",
                            { staticClass: "info-overlay__text right-auto" },
                            [_vm._v(_vm._s(_vm.infoText[3]))]
                          )
                        ])
                      ])
                    ]),
                    _c("td", [
                      _vm._v(
                        _vm._s(_vm.$parent.formatPercent(_vm.yearlyYield, 2))
                      )
                    ])
                  ]),
                  _c("tr", [
                    _c("td", [
                      _c("div", { staticClass: "spv-info-wrapper" }, [
                        _vm._v("Maßgebliche "),
                        _c("div", { staticClass: "info-overlay" }, [
                          _vm._v("Jahresrendite "),
                          _vm._m(5),
                          _c(
                            "div",
                            { staticClass: "info-overlay__text right-auto" },
                            [_vm._v(_vm._s(_vm.infoText[4]))]
                          )
                        ])
                      ])
                    ]),
                    _c("td", [
                      _vm._v(
                        _vm._s(_vm.$parent.formatPercent(_vm.decisiveYield, 2))
                      )
                    ])
                  ])
                ])
              ]
            )
          ]),
          _c("div", { staticClass: "row pdf-button-wrapper d-flex" }, [
            _c("div", { staticClass: "small-6 columns text-left" }, [
              _vm.factsheetPath && _vm.indexId === "trend"
                ? _c(
                    "a",
                    {
                      staticClass: "button button-small",
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          _vm.onOpenFactsheet()
                        }
                      }
                    },
                    [_vm._v("Download Factsheet")]
                  )
                : _vm._e()
            ]),
            _c("div", { staticClass: "small-6 columns text-right" }, [
              _c(
                "a",
                {
                  staticClass: "button button-small",
                  on: {
                    click: function($event) {
                      _vm.$emit("print")
                    }
                  }
                },
                [_vm._v("Drucken")]
              )
            ])
          ])
        ])
      : _c("div", { staticClass: "medium-12 large-12 columns" }, [
          _c("h1", { staticClass: "no-margin" }, [
            _vm._v(
              "Keine Monatswerte für " +
                _vm._s(_vm.indexName) +
                " für " +
                _vm._s(_vm.month) +
                " vorhanden."
            )
          ]),
          _vm.factsheetPath && _vm.indexId === "trend"
            ? _c("div", { staticClass: "text-left mt-3" }, [
                _c(
                  "a",
                  {
                    staticClass: "button button-small",
                    on: {
                      click: function($event) {
                        $event.stopPropagation()
                        _vm.onOpenFactsheet()
                      }
                    }
                  },
                  [_vm._v("Download Factsheet")]
                )
              ])
            : _vm._e()
        ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "info-overlay__icon" }, [
      _c("i", { staticClass: "fo icon-info_kreis" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "info-overlay__icon" }, [
      _c("i", { staticClass: "fo icon-info_kreis" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", [
      _vm._v("Indexstand"),
      _c("br"),
      _vm._v("jeweils am"),
      _c("br"),
      _vm._v("Ende des Monats")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "info-overlay__icon header-info" }, [
      _c("i", { staticClass: "fo icon-info_kreis" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "info-overlay__icon" }, [
      _c("i", { staticClass: "fo icon-info_kreis" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "info-overlay__icon" }, [
      _c("i", { staticClass: "fo icon-info_kreis" })
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-32f04462", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-32f04462","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug&optionsId=0!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/apps/index/index-trend-table.vue
// module id = pytl
// module chunks = 0